import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { getProteinTargetG } from "./quiz/protein";

import styled, { css, keyframes } from "styled-components";

import { Model } from "survey-core";
import { useChartCalculations } from './charts/utils';
import { PageContainer } from './common-ui/PageContainer';

import { useAppProgramLevelConfigs } from './features/programs/Program.config';

import { CDN_ROOT, getCdnImageUrl } from "./features/images";
import { Footer } from './Footer';
import {
  sendViewItemEvent,
  sendViewItemListEvent,
} from "./services/googleTagManager";
import { saveTimeToGoalToHubspot } from './services/hubspot';
import { decorateUrlWithAttributionParams } from './services/checkoutAttribution';
import { User } from "./types";

import * as amplitude from "@amplitude/analytics-browser";
import { Identify } from "@amplitude/analytics-browser";
import Cookies from "js-cookie";
import { round } from "lodash";
import TransformationSlider from "./charts/CustomSlider";
import TransformationSliderDesktop from "./charts/CustomSliderDesktop";
import { useIsMobile } from "./features/useIsMobile";

import { Interval } from "luxon";
import { getGenderKey } from './features/utils';
import { useWindowResize } from './hooks/useWindowResize';
import { getWeightKg, WeightUnit } from "./quiz/weight";
import { LoadingPageV2 } from './features/checkout/LoadingPageV2';
import { LoadingPagePlanReady } from './features/checkout/LoadingPagePlanReady';
import { WelcomeKitIntro } from './features/welcomeKit/WelcomeKitIntro';
import { Project60StickyBanner as Quiz4UrgencyBanner } from './features/Quiz4UrgencyBanner';
import { getAssignedExperimentArm, getLandingPageSurveyItems, getUTMParams, getWeb35Arm, getWeb41Arm, getWeb46Arm, trackWeb46Exposure, getWeb48Arm, getWeb48EndsAt, trackWeb48Exposure, getWelcomeKitAssignment, WEB35_EXPERIMENT_NAME, WEB41_EXPERIMENT_NAME } from './utils';
import { MatchOfferState, pickMatchReason, readMatchOfferState, writeMatchOfferState } from './features/web46/matchOffer';
import { MatchOfferModal } from './features/web46/MatchOfferModal';
import { ReservationEntry } from './features/reservation/ReservationEntry';
import { useWeb29Offer } from './hooks/useWeb29Offer';
import { Web48Banner } from './features/web48/Web48Banner';
import { getBfSale } from './bfSale';
import { getBfBannerDesign } from './utils';
import { StatsigClient } from '@statsig/js-client';
import { useDevHelper } from './hooks/useDevHelper';
import { Banner } from './features/Banner';
import { Age } from './quiz/age';
import PricingExtrasWeb24 from './features/PricingExtrasWeb24';
import { trackPricingCtaClicked, useSectionInView } from './features/useSectionInView';
import PricingPlans from './features/PricingPlans';
import PricingPlansWeb21 from './features/PricingPlansWeb21';
import { useReferral } from './referral';
import { useTranslation } from 'react-i18next';
import i18n from './i18n';

// Helper function to find nearest number in a list
function findNearestNumber(num: number, list: number[]): number {
  if (list.includes(num)) {
    return num;
  }
  let nearest: number = list[0];
  let minDiff: number = Math.abs(num - nearest);
  for (let i = 1; i < list.length; i++) {
    let diff: number = Math.abs(num - list[i]);
    if (diff < minDiff) {
      minDiff = diff;
      nearest = list[i];
    }
  }
  return nearest;
}

// Helper function to convert kg to lbs
function kgToLbs(kg: number): number {
  const POUNDS_PER_KG = 2.20462;
  return round(kg * POUNDS_PER_KG);
}

// Helper function to convert lbs to kg
function lbsToKg(lbs: number): number {
  const POUNDS_PER_KG = 2.20462;
  return round(lbs / POUNDS_PER_KG);
}

export function getTransformationData(user: User, timeToGoal: Interval, CDN_ROOT: string) {
  const male_image = "Male";
  const femaile_image = "Female";

  const nextThreeMonths = getNextThreeMonths(timeToGoal);
  // Displayed labels in the active language (numbers interpolated as the old
  // string concatenation printed them).
  const tl = (key: string, value?: unknown): string =>
    i18n.t(`results.transformation.${key}`, { value: String(value) });

  const sliderscount = getSliderCount(timeToGoal);

  const userGender = getGenderKey(user.gender, user.physiology);
  const gender_prefix = userGender === 'Male' ? male_image : femaile_image;

  const image_url1=user.bodyFat;
  let image_url2=25;
  let image_url3=22;
  let image_url4 :number|undefined =20;


  let goal_body_fat2=25;
  let goal_body_fat3=22;
  let goal_body_fat4:number|undefined =20;


  let current_weight_lbs :number   = 100;

  let current_weight_kg:number   = 100;

  // Example usage:
  const _female_numbers = [15,18,20,22,25,28,30,32,35,38,40,42,45,50];
  const _male_number= [10,12,15,18,20,22,25,28,30,32,35,40];

  let label_goal="Body Fat";
  let label_bodyfat1;
  let label_bodyfat2;
  let label_bodyfat3;
  let label_bodyfat4;

  let label_bodyfat1_alt;
  let label_bodyfat2_alt;
  let label_bodyfat3_alt;
  let label_bodyfat4_alt;

  if (user.weightUnit === "kgs") {
      current_weight_kg = user.weight;
      current_weight_lbs = kgToLbs(user.weight);
  } else {
      current_weight_kg = lbsToKg(user.weight);
      current_weight_lbs = user.weight;
  }

  //console.log('current_weight_lbs',current_weight_lbs);
  //console.log("Goal",user.goals);
  //console.log("current body fat",user.bodyFat);

  if (user.goals === "Lose Fat Most Important") {
      if (user.goalBodyFat !== undefined) {
          image_url4 = user.goalBodyFat;
          goal_body_fat4 = user.goalBodyFat;

          if (userGender === "Male") {
              let goal_body_fat2temp = round(
                  user.bodyFat -
                      Number(user.bodyFat - user.goalBodyFat) * (30 / 100)
              );
              goal_body_fat2 = findNearestNumber(
                  goal_body_fat2temp,
                  _male_number
              );
              if (sliderscount === 3) {
                  let goal_body_fat2temp = round(
                      user.bodyFat -
                          Number(user.bodyFat - user.goalBodyFat) * (50 / 100)
                  );
                  goal_body_fat2 = findNearestNumber(
                      goal_body_fat2temp,
                      _male_number
                  );
              }
              let goal_body_fat3temp = round(
                  goal_body_fat2temp -
                      Number(user.bodyFat - user.goalBodyFat) * (40 / 100)
              );
              goal_body_fat3 = findNearestNumber(
                  goal_body_fat3temp,
                  _male_number
              );
              image_url2 = goal_body_fat2;
              image_url3 = goal_body_fat3;
              label_goal = "Body Fat";
              label_bodyfat1 = tl("bodyFatToday", user.bodyFat);
              label_bodyfat2 = tl("bodyFatShort", goal_body_fat2temp);
              label_bodyfat3 = tl("bodyFatShort", goal_body_fat3temp);
              label_bodyfat4 = tl("bodyFatShort", goal_body_fat4);
          } else {
              let goal_body_fat2temp = round(
                  user.bodyFat -
                      Number(user.bodyFat - user.goalBodyFat) * (30 / 100)
              );
              goal_body_fat2 = findNearestNumber(
                  goal_body_fat2temp,
                  _female_numbers
              );
              if (sliderscount === 3) {
                  let goal_body_fat2temp = round(
                      user.bodyFat -
                          Number(user.bodyFat - user.goalBodyFat) * (50 / 100)
                  );
                  goal_body_fat2 = findNearestNumber(
                      goal_body_fat2temp,
                      _female_numbers
                  );
              }
              let goal_body_fat3temp = round(
                  goal_body_fat2temp -
                      Number(user.bodyFat - user.goalBodyFat) * (40 / 100)
              );
              goal_body_fat3 = findNearestNumber(
                  goal_body_fat3temp,
                  _female_numbers
              );
              image_url2 = goal_body_fat2;
              image_url3 = goal_body_fat3;
              goal_body_fat2 = goal_body_fat2temp;
              goal_body_fat3 = goal_body_fat3temp;
              label_goal = "Body Fat";
              label_bodyfat1 = tl("bodyFatToday", user.bodyFat);
              label_bodyfat2 = tl("bodyFatShort", goal_body_fat2temp);
              label_bodyfat3 = tl("bodyFatShort", goal_body_fat3temp);
              label_bodyfat4 = tl("bodyFatShort", goal_body_fat4);
          }
      }
      label_bodyfat1_alt = user.bodyFat;
      label_bodyfat2_alt = goal_body_fat2;
      label_bodyfat3_alt = goal_body_fat3;
      label_bodyfat4_alt = goal_body_fat4;
  } else if (user.goals === "Build Muscle Most Important") {
      let goal_muscule_gain = 10;
      if (user.muscleGain !== undefined) {
          if (user.muscleGain === -1 || user.muscleGain === 999) {
              if (user.experience === "Beginner") {
                  goal_muscule_gain = 18;
              } else {
                  goal_muscule_gain = 12;
              }
          } else {
              goal_muscule_gain = user.muscleGain;
          }
      }
      console.log("goal_muscule_gain", goal_muscule_gain);
      if (userGender === "Male") {
          let goal_bodyfat_muscule2 = goal_muscule_gain * 0.3;
          let goal_body_fat2_temp = round(
              (((current_weight_lbs * user.bodyFat) / 100 -
                  goal_bodyfat_muscule2) /
                  current_weight_lbs) *
                  100
          );
          console.log("goal_body_fat2_temp", goal_body_fat2_temp);

          goal_body_fat2 = findNearestNumber(goal_body_fat2_temp, _male_number);
          if (sliderscount === 3) {
              let goal_bodyfat_muscule2 = goal_muscule_gain * 0.5;
              let goal_body_fat2_temp = round(
                  (((current_weight_lbs * user.bodyFat) / 100 -
                      goal_bodyfat_muscule2) /
                      current_weight_lbs) *
                      100
              );
              console.log("goal_body_fat2_temp", goal_body_fat2_temp);

              goal_body_fat2 = findNearestNumber(
                  goal_body_fat2_temp,
                  _male_number
              );
          }

          let goal_bodyfat_muscule3 = goal_muscule_gain * 0.4;
          let goal_body_fat3_temp = round(
              (((current_weight_lbs * goal_body_fat2_temp) / 100 -
                  goal_bodyfat_muscule3) /
                  current_weight_lbs) *
                  100
          );
          console.log("goal_body_fat3_temp", goal_body_fat3_temp);
          goal_body_fat3 = findNearestNumber(goal_body_fat3_temp, _male_number);
          let goal_bodyfat_muscule4 = goal_muscule_gain * 0.3;
          let goal_body_fat4_temp = round(
              (((current_weight_lbs * goal_body_fat3_temp) / 100 -
                  goal_bodyfat_muscule4) /
                  current_weight_lbs) *
                  100
          );
          console.log("goal_body_fat4_temp", goal_body_fat4_temp);
          goal_body_fat4 = findNearestNumber(goal_body_fat4_temp, _male_number);

          image_url2 = goal_body_fat2;
          image_url3 = goal_body_fat3;
          image_url4 = goal_body_fat4;

          goal_body_fat2 = goal_body_fat2_temp;
          goal_body_fat3 = goal_body_fat3_temp;
          goal_body_fat4 = goal_body_fat4_temp;
      } else {
          let goal_bodyfat_muscule2 = goal_muscule_gain * 0.3;
          let goal_body_fat2_temp = round(
              (((current_weight_lbs * user.bodyFat) / 100 -
                  goal_bodyfat_muscule2) /
                  current_weight_lbs) *
                  100
          );
          console.log("goal_body_fat2_temp", goal_body_fat2_temp);

          goal_body_fat2 = findNearestNumber(
              goal_body_fat2_temp,
              _female_numbers
          );

          if (sliderscount === 3) {
              let goal_bodyfat_muscule2 = goal_muscule_gain * 0.5;
              let goal_body_fat2_temp = round(
                  (((current_weight_lbs * user.bodyFat) / 100 -
                      goal_bodyfat_muscule2) /
                      current_weight_lbs) *
                      100
              );
              console.log("goal_body_fat2_temp", goal_body_fat2_temp);

              goal_body_fat2 = findNearestNumber(
                  goal_body_fat2_temp,
                  _female_numbers
              );
          }
          let goal_bodyfat_muscule3 = goal_muscule_gain * 0.4;
          let goal_body_fat3_temp = round(
              (((current_weight_lbs * goal_body_fat2_temp) / 100 -
                  goal_bodyfat_muscule3) /
                  current_weight_lbs) *
                  100
          );
          console.log("goal_body_fat3_temp", goal_body_fat3_temp);
          goal_body_fat3 = findNearestNumber(
              goal_body_fat3_temp,
              _female_numbers
          );
          let goal_bodyfat_muscule4 = goal_muscule_gain * 0.3;
          let goal_body_fat4_temp = round(
              (((current_weight_lbs * goal_body_fat3_temp) / 100 -
                  goal_bodyfat_muscule4) /
                  current_weight_lbs) *
                  100
          );
          console.log("goal_body_fat4_temp", goal_body_fat4_temp);
          goal_body_fat4 = findNearestNumber(
              goal_body_fat4_temp,
              _female_numbers
          );
          image_url2 = goal_body_fat2;
          image_url3 = goal_body_fat3;
          image_url4 = goal_body_fat4;
          goal_body_fat2 = goal_body_fat2_temp;
          goal_body_fat3 = goal_body_fat3_temp;
          goal_body_fat4 = goal_body_fat4_temp;
      }

      label_goal = "Body Muscle Gain";
      if (user.weightUnit === "lbs") {
          label_bodyfat1 = tl("noGainsYet");
          label_bodyfat2 = "+" + tl("muscleLbs", round(goal_muscule_gain * 0.3));
          label_bodyfat3 = "+" + tl("muscleLbs", round(goal_muscule_gain * 0.7));
          label_bodyfat4 = "+" + tl("muscleLbs", goal_muscule_gain);
      } else {
          const goal_muscule_gain_kg = getWeightKg(
              goal_muscule_gain,
              WeightUnit.Pounds
          );
          label_bodyfat1 = tl("noGainsYet");
          label_bodyfat2 = "+" + tl("muscleKg", round(goal_muscule_gain_kg * 0.3));
          label_bodyfat3 = "+" + tl("muscleKg", round(goal_muscule_gain_kg * 0.7));
          label_bodyfat4 = tl("muscleKg", goal_muscule_gain_kg);
      }

      label_bodyfat1_alt = user.bodyFat;
      label_bodyfat2_alt = goal_body_fat2;
      label_bodyfat3_alt = goal_body_fat3;
      label_bodyfat4_alt = goal_body_fat4;
  } else {
      //Lose weight
      let goal_weight_lbs = 10;

      let goal_weight_difference_kg = 10;
      let goal_weight_kg = 100;
      if (user.weightUnit === "kgs") {
          if (user.goalWeight !== undefined) {
              goal_weight_lbs = kgToLbs(user.goalWeight);
              goal_weight_kg = user.goalWeight;
          }
      } else {
          if (user.goalWeight !== undefined) {
              goal_weight_lbs = user.goalWeight;
              goal_weight_kg = lbsToKg(user.goalWeight);
          }
      }

      const goal_weight_difference = current_weight_lbs - goal_weight_lbs;
      goal_weight_difference_kg = current_weight_kg - goal_weight_kg;
      //console.log('goal_weight_difference',goal_weight_difference);
      if (userGender === "Male") {
          let goal_body_fat2_temp = round(
              (((current_weight_lbs * user.bodyFat) / 100 -
                  goal_weight_difference / 4) /
                  (current_weight_lbs - goal_weight_difference / 4)) *
                  100
          );
          goal_body_fat2 = findNearestNumber(goal_body_fat2_temp, _male_number);

          if (sliderscount === 3) {
              let goal_body_fat2_temp = round(
                  (((current_weight_lbs * user.bodyFat) / 100 -
                      goal_weight_difference / 2) /
                      (current_weight_lbs - goal_weight_difference / 2)) *
                      100
              );
              goal_body_fat2 = findNearestNumber(
                  goal_body_fat2_temp,
                  _male_number
              );
          }
          //console.log('goal_body_fat2_temp',goal_body_fat2_temp);
          let goal_body_fat3_temp = round(
              (((current_weight_lbs - goal_weight_difference / 4) *
                  (goal_body_fat2_temp / 100) -
                  goal_weight_difference / 2) /
                  (current_weight_lbs -
                      goal_weight_difference / 4 -
                      goal_weight_difference / 2)) *
                  100
          );
          goal_body_fat3 = findNearestNumber(goal_body_fat3_temp, _male_number);
          //console.log('goal_body_fat3',goal_body_fat3_temp);
          let goal_body_fat4_temp = round(
              (((current_weight_lbs -
                  goal_weight_difference / 4 -
                  goal_weight_difference / 2) *
                  (goal_body_fat3_temp / 100) -
                  goal_weight_difference / 4) /
                  (current_weight_lbs -
                      goal_weight_difference / 4 -
                      goal_weight_difference / 2 -
                      goal_weight_difference / 4)) *
                  100
          );

          goal_body_fat4 = findNearestNumber(goal_body_fat4_temp, _male_number);
          //console.log('goal_body_fat4',goal_body_fat4_temp);
          image_url2 = goal_body_fat2;
          image_url3 = goal_body_fat3;
          image_url4 = goal_body_fat4;
          goal_body_fat2 = goal_body_fat2_temp;
          goal_body_fat3 = goal_body_fat3_temp;
          goal_body_fat4 = goal_body_fat4_temp;
      } else {
          let goal_body_fat2_temp = round(
              (((current_weight_lbs * user.bodyFat) / 100 -
                  goal_weight_difference / 4) /
                  (current_weight_lbs - goal_weight_difference / 4)) *
                  100
          );
          goal_body_fat2 = findNearestNumber(
              goal_body_fat2_temp,
              _female_numbers
          );

          if (sliderscount === 3) {
              let goal_body_fat2_temp = round(
                  (((current_weight_lbs * user.bodyFat) / 100 -
                      goal_weight_difference / 2) /
                      (current_weight_lbs - goal_weight_difference / 2)) *
                      100
              );
              goal_body_fat2 = findNearestNumber(
                  goal_body_fat2_temp,
                  _female_numbers
              );
          }
          //console.log('goal_body_fat2_temp',goal_body_fat2_temp);
          let goal_body_fat3_temp = round(
              (((current_weight_lbs - goal_weight_difference / 4) *
                  (goal_body_fat2_temp / 100) -
                  goal_weight_difference / 2) /
                  (current_weight_lbs -
                      goal_weight_difference / 4 -
                      goal_weight_difference / 2)) *
                  100
          );
          goal_body_fat3 = findNearestNumber(
              goal_body_fat3_temp,
              _female_numbers
          );
          //console.log('goal_body_fat3',goal_body_fat3_temp);
          let goal_body_fat4_temp = round(
              (((current_weight_lbs -
                  goal_weight_difference / 4 -
                  goal_weight_difference / 2) *
                  (goal_body_fat3_temp / 100) -
                  goal_weight_difference / 4) /
                  (current_weight_lbs -
                      goal_weight_difference / 4 -
                      goal_weight_difference / 2 -
                      goal_weight_difference / 4)) *
                  100
          );

          goal_body_fat4 = findNearestNumber(
              goal_body_fat4_temp,
              _female_numbers
          );
          //console.log('goal_body_fat4',goal_body_fat4_temp);
          image_url2 = goal_body_fat2;
          image_url3 = goal_body_fat3;
          image_url4 = goal_body_fat4;
          goal_body_fat2 = goal_body_fat2_temp;
          goal_body_fat3 = goal_body_fat3_temp;
          goal_body_fat4 = goal_body_fat4_temp;
      }

      label_goal = "Weight Loss";
      if (user.weightUnit === "lbs") {
          label_bodyfat1 = current_weight_lbs + " lbs";
          label_bodyfat2 =
              round(current_weight_lbs - goal_weight_difference * 0.3) + " lbs";
          label_bodyfat3 =
              round(current_weight_lbs - goal_weight_difference * 0.7) + " lbs";
          label_bodyfat4 = goal_weight_lbs + " lbs";
      } else {
          label_bodyfat1 = current_weight_kg + " kg";
          label_bodyfat2 =
              round(current_weight_kg - goal_weight_difference_kg * 0.3) + " kg";
          label_bodyfat3 =
              round(current_weight_kg - goal_weight_difference_kg * 0.7) + " kg";
          label_bodyfat4 = goal_weight_kg + " kg";
      }

      label_bodyfat1_alt = user.bodyFat;
      label_bodyfat2_alt = goal_body_fat2;
      label_bodyfat3_alt = goal_body_fat3;
      label_bodyfat4_alt = goal_body_fat4;
  }

  let experienceLevel1="Beginner";
  let experienceLevel2="Novice";
  let experienceLevel3="Intermediate";
  let experienceLevel4="Advanced";

  if(user.experience === "Intermediate"){
    experienceLevel1="Intermediate";
  experienceLevel2="Advanced";
  experienceLevel3="Expert";
  experienceLevel4="Elite";
  }


  const getTransformationImageUrl = (imageName: string | number) =>
    getCdnImageUrl(`images/new-quiz-bodyfat-images/${gender_prefix}/${imageName}.png`);

  let transformationData =
  [
      {
        id: 'today',
        index: 0,
        timelineLabel: tl('today'),
        subtitle: 'Getting Started',
        labelgoal: label_goal,
        labelbodyfat:label_bodyfat1,
        label_bodyfat_alt:label_bodyfat1_alt,
        imageUrl: getTransformationImageUrl(image_url1),
        bodyFat: user.bodyFat+'%',
        experienceLevel: experienceLevel1,
        description: tl('description.start'),
      },
      {
        id:  nextThreeMonths[0],
        index: 1,
        timelineLabel: nextThreeMonths[0],
        label_bodyfat_alt:label_bodyfat2_alt,
        subtitle: 'Seeing Changes', // Example subtitle
        labelgoal: label_goal,
        labelbodyfat:label_bodyfat2,
        imageUrl: getTransformationImageUrl(image_url2),
        bodyFat: goal_body_fat2+'%', // Example data
        experienceLevel: experienceLevel2, // Example data
        description: tl('description.momentum'),
      },
      {
        id:  nextThreeMonths[1],
        index: 2,
        timelineLabel: nextThreeMonths[1],
        label_bodyfat_alt:label_bodyfat3_alt,
        subtitle: 'Major Progress', // Example subtitle
        labelgoal: label_goal,
        labelbodyfat:label_bodyfat3,
        imageUrl: getTransformationImageUrl(image_url3),
        bodyFat: goal_body_fat3+'%', // Example data
        experienceLevel: experienceLevel3, // Example data
        description: tl('description.definition'),
      },
      {
        id:  nextThreeMonths[2],
        index: 3,
        timelineLabel: nextThreeMonths[2],

        subtitle: 'Goal Achieved', // Example subtitle
        labelgoal: label_goal,
        labelbodyfat:label_bodyfat4,
        label_bodyfat_alt:label_bodyfat4_alt,
        imageUrl: getTransformationImageUrl(image_url4),
        bodyFat: goal_body_fat4+'%', // Example data
        experienceLevel: experienceLevel4, // Example data
        description: tl('description.goal'),
      },
    ];
    // --- End Placeholder Data ---

  if(sliderscount === 3){



  transformationData = [
      {
        id: 'today',
        index: 0,
        timelineLabel: tl('today'),
        subtitle: 'Getting Started',
        labelgoal: label_goal,
        labelbodyfat:label_bodyfat1,
        label_bodyfat_alt:label_bodyfat1_alt,
        imageUrl: getTransformationImageUrl(image_url1),
        bodyFat: user.bodyFat+'%',
        experienceLevel: experienceLevel1,
        description: tl('description.start'),
      },
      {
        id:  nextThreeMonths[0],
        index: 1,

        timelineLabel: nextThreeMonths[0],
        subtitle: 'Seeing Changes', // Example subtitle
        labelgoal: label_goal,
        labelbodyfat:label_bodyfat2,
        label_bodyfat_alt:label_bodyfat2_alt,
        imageUrl: getTransformationImageUrl(image_url2),
        bodyFat: goal_body_fat2+'%', // Example data
        experienceLevel:experienceLevel2, // Example data
        description: tl('description.momentum'),
      },
    
      {
        id:  nextThreeMonths[2],
        index: 2,
        timelineLabel: nextThreeMonths[2],
        label_bodyfat_alt:label_bodyfat4_alt,
        subtitle: 'Goal Achieved', // Example subtitle
        labelgoal: label_goal,
        labelbodyfat:label_bodyfat4,
        imageUrl: getTransformationImageUrl(image_url4),
        bodyFat: goal_body_fat4+'%', // Example data
        experienceLevel: experienceLevel3, // Example data
        description: tl('description.goal'),
      },
    ];
    // --- End Placeholder Data ---

  }

  return transformationData;
}

const LandingPageContainerSlider = styled(PageContainer)`
  margin: 0;
  background-color: #F5F5F5;
  max-width: 100%;
  padding-bottom: 0px;
  @media (max-width: 500px) {
    padding-top: 0px;
    max-width: 100%;
  }
`;

const ChartWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  @media (max-width: 800px) {
    min-width: 100vw;
    margin-bottom: 0px;
  }
`;

const StartNowButton = styled.button`
width: 100%;
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 0px;

  background: #DFB140;
  border-radius: 8px;

  font-family: 'Oswald';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 37px;
  text-align: center;
  color: #000000;
  text-transform: uppercase;

  @media (min-width: 768px) {
    font-size: 32px;
    line-height: 48px;
    padding: 16px 0px;
  }

  text-decoration: none; /* Remove underline from link */
  display: inline-block;
  transition: background-color 0.3s ease, opacity 0.3s ease, transform 0.2s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  max-width: 350px;
  border: none;
  /* Conditional styles for disabled state */
  cursor: pointer;
  /* Prevent clicking/interaction when disabled */
  pointer-events: auto;

  /* Hover effect only when not disabled */
  &:hover {
    background-color: rgb(64, 110, 223);
    transform: translateY(-2px);
    color: white;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }

  /* Focus outline for accessibility */
  &:focus {
    outline: 2px solid #dfb140; /* Outline matching button color */
    outline-offset: 3px;
  }
  &:focus:not(:focus-visible) {
    outline: none; /* Remove outline for mouse users */
  }
`;

const RestartQuizButton = styled.button`
  text-decoration: underline;
  cursor: pointer;
  outline: none;
  border: none;
  background: none;
  font-size: 16px;
  margin: 0 auto;
  padding-bottom: 20px;
  display: block;
`;

const SliderSection = styled.section`
  padding: 0px;
  width: 100%;
`;

const SliderSectionFixed = styled.section`
  padding-top: 30px;
  width: 100%;
`;

const SliderContairner = styled.div`
  display: block;
  margin: 0 auto;
  padding: 0px;
  max-width: 100%;
  min-height: 50vh;
`;

const StartButtonWrapperSlider = styled.div`
  display: flex;
  margin: 0px auto;
  -webkit-box-pack: center;
  justify-content: center;
  padding-bottom: 20px;
  align-items: center;
  flex-direction: column;
  margin-top: 12px;

  @media (min-width: 768px) {
    margin-top: 24px;
  }
`;

// --- Animation Definition ---
const floatUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px); /* Start 30px lower */
  }
  to {
    opacity: 1;
    transform: translateY(0); /* End at normal position */
  }
`;

// --- Reusable Animation Styles (Mixin) ---
// This replaces the need for the separate '.animation-item' class
const animationItemStyles = css`
  opacity: 0; /* Start invisible */
  animation-name: ${floatUp};
  animation-duration: 0.6s; /* Animation speed */
  animation-timing-function: ease-out; /* Animation curve */
  animation-fill-mode: forwards; /* Stay visible after animating */
`;

export const LoadingDots = styled.div`
  margin: 0 auto;
  max-width: 133px;
  ${animationItemStyles}
  animation-delay: 0.7s; /* Dots appear last */
  @media (max-width: 800px) {
    max-width: 80px;
  }
`;

type LandingPageProps = {
  user: User;
  onComplete: () => void;
  TEST_USE_DURATIONS?: boolean;
  survey: Model;
  client: StatsigClient;
  isClientLoading: boolean;
};

function get_ga_clientid() {
  const gaCookie = Cookies.get('_ga');
  if (!gaCookie) {
    return null;
  }
  return gaCookie.split('.').slice(2).join('.');
}

function getAmplitudeDeviceId() {
  return Cookies.get('bws_amplitude_device_id');
}

export function decorateUrlWithUTMParams(url: URL): URL {
  return decorateUrlWithAttributionParams(url);
}

const generateUtmQueryString = () => {
  const params = getUTMParams();

  if (params) {
    const queryString = Object.entries(params)
      .filter(([_, value]) => value !== null && value !== '')
      .map(([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join('&');

    return queryString.length > 0 ? `${queryString}` : '';
  }

  return '';
};

export type CheckoutPlan = {
  id: string;
  isMultiUser?: boolean;
  tagTheme?: "blue" | "green" | "yellow";
  title: string;
  tagline: string;
  price: string;
  fullPriceForBoth?: string;
  priceDetails: string;
  billingDetails?: string;
  comparisonText?: string;
  description: string;
  icon: React.ReactNode;
  checkoutUrl: string;
  priceRaw: number;
  isOneTime?: boolean;
  isMonthly?: boolean;
  priceId?: string;
  unlockProductId?: string;
  trialProductId?: string;
  badge?: string;
  discount?: string;
  promotionCode?: string;
  tagSavePercentage?: string;
  tagLabel?: string;
  oldPrice?: string;
  experiments?: {
    [key: string]: Record<string, string | number | boolean>;
  };
}

export function getPlans(baseLink: string = "", premiumLink: string = "", eliteLink: string = ""): CheckoutPlan[] {
  const plans: CheckoutPlan[] = [
    {
      id: "serious",
      title: "Getting Serious",
      tagline: "\"I've got goals and I'm carving out time.\"",
      price: "$29.99",
      priceDetails: "/ month", // Added space for clarity
      description:
        "You're still feeling things out, but you're ready to show up consistently and start putting in some real effort.",
      icon: (
        <svg
          width="48"
          height="49"
          viewBox="0 0 48 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect y="0.833984" width="48" height="48" rx="24" fill="#E7F0FF" />
          <path
            d="M19.7002 14.084V18.3839M28.2999 14.084V18.3839"
            stroke="#0B6DFF"
            stroke-width="2.14994"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M31.5247 16.2344H16.4751C15.2878 16.2344 14.3252 17.1969 14.3252 18.3843V33.4339C14.3252 34.6212 15.2878 35.5838 16.4751 35.5838H31.5247C32.7121 35.5838 33.6746 34.6212 33.6746 33.4339V18.3843C33.6746 17.1969 32.7121 16.2344 31.5247 16.2344Z"
            stroke="#0B6DFF"
            stroke-width="2.14994"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14.3252 22.6836H33.6746M20.775 29.1334L22.9249 31.2833L27.2248 26.9835"
            stroke="#0B6DFF"
            stroke-width="2.14994"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
  
      checkoutUrl: premiumLink, // Replace with actual checkout link
      priceRaw: 29.99,
      isOneTime: false,
      isMonthly: true,
      priceId: "price_1QVNrqJnrTlLWSIiB4TRe2xF",
      unlockProductId: "prod_R3V51NYeGIztoo",
      trialProductId: "prod_RO8biM4NUE1Wws",
      discount: "FRRBtKVo",
      experiments: {
        web17_3: {
          discount: "rfb53wVj",
          newPrice: "$19.99",
          oldPrice: "$29.99",
        }
      }
    },
    {
      id: "committed",
      title: "Fully Committed",
      tagline: "\"This isn't just a phase, it's who I am.\"",
      price: "$15.99",
      priceDetails: "/ month", // Added space for clarity
      billingDetails: "(billed annually)",
      description:
        "This is your lifestyle now. You're looking for structure and long-term support to help you stay on track.",
      icon: (
        <svg
          width="29"
          height="29"
          viewBox="0 0 29 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5635 4.62598H18.2705C18.4805 4.62598 18.6613 4.62598 18.8247 4.64581C19.41 4.71871 19.9537 4.98662 20.3681 5.40634C20.7825 5.82606 21.0435 6.37312 21.109 6.95931H22.0493C22.2967 6.95698 22.8392 6.95231 23.2872 7.25214C23.867 7.63831 24.042 8.30214 24.042 9.00098C24.042 12.1813 22.3468 14.3046 20.1827 15.4841C18.9752 17.6821 16.7445 19.2093 14.417 19.2093C12.6448 19.2093 10.9637 18.2503 9.75383 16.9238C9.35183 16.4852 8.99895 16.004 8.70149 15.4888C6.53849 14.3151 4.79199 12.1941 4.79199 9.00098C4.79199 8.30098 4.96699 7.63831 5.54566 7.25214C5.99483 6.95231 6.53733 6.95698 6.78466 6.95931H7.72499L7.72849 6.92664C7.80063 6.34686 8.06412 5.8077 8.47725 5.39457C8.89039 4.98144 9.42954 4.71794 10.0093 4.64581C10.1727 4.62598 10.3535 4.62598 10.5635 4.62598ZM9.45866 7.83431V7.83781L9.44699 11.9176V11.9188C9.44699 12.76 9.68733 13.6198 10.1038 14.4073L10.1202 14.4365C10.371 14.9055 10.6848 15.3465 11.0477 15.7431C12.03 16.8211 13.2737 17.4593 14.4182 17.4593C16.0772 17.4593 17.826 16.26 18.7348 14.4913C19.1477 13.6962 19.3637 12.8136 19.3648 11.9176L19.3625 11.9153L19.3765 7.52748C19.3765 7.24514 19.3742 7.18331 19.3695 7.14248C19.3453 6.94947 19.2575 6.77002 19.12 6.63248C18.9824 6.49494 18.803 6.40715 18.61 6.38298C18.4818 6.37535 18.3534 6.37301 18.225 6.37598H10.6102C10.3267 6.37598 10.266 6.37714 10.2252 6.38298C10.0322 6.40715 9.8527 6.49494 9.71516 6.63248C9.57762 6.77002 9.48983 6.94947 9.46566 7.14248C9.45803 7.27066 9.45569 7.3991 9.45866 7.52748V7.83431ZM21.123 8.70931L21.1125 11.9176V11.9188M21.0857 12.5476C21.83 11.6516 22.2932 10.4826 22.2932 9.00098C22.2932 8.86331 22.2815 8.77231 22.271 8.71514C22.1813 8.70974 22.0914 8.70779 22.0015 8.70931H21.123M7.72033 12.48C7.70273 12.2931 7.69416 12.1054 7.69466 11.9176V11.9153L7.70516 8.70931H6.83366C6.70649 8.70931 6.62599 8.70931 6.56416 8.71514C6.54776 8.80951 6.54034 8.90521 6.54199 9.00098C6.54199 10.4441 6.99466 11.591 7.72033 12.48ZM14.417 19.7926C14.6491 19.7926 14.8716 19.8848 15.0357 20.0489C15.1998 20.213 15.292 20.4356 15.292 20.6676V23.2926H19.0837C19.3157 23.2926 19.5383 23.3848 19.7024 23.5489C19.8665 23.713 19.9587 23.9356 19.9587 24.1676C19.9587 24.3997 19.8665 24.6223 19.7024 24.7864C19.5383 24.9505 19.3157 25.0426 19.0837 25.0426H9.75033C9.51826 25.0426 9.2957 24.9505 9.13161 24.7864C8.96751 24.6223 8.87533 24.3997 8.87533 24.1676C8.87533 23.9356 8.96751 23.713 9.13161 23.5489C9.2957 23.3848 9.51826 23.2926 9.75033 23.2926H13.542V20.6676C13.542 20.4356 13.6342 20.213 13.7983 20.0489C13.9624 19.8848 14.1849 19.7926 14.417 19.7926Z"
            fill="white"
          />
          <path
            d="M14.1478 8.48107C14.1702 8.42845 14.2076 8.38359 14.2553 8.35206C14.303 8.32052 14.359 8.30371 14.4162 8.30371C14.4734 8.30371 14.5293 8.32052 14.577 8.35206C14.6247 8.38359 14.6621 8.42845 14.6845 8.48107L15.2737 9.89507C15.2942 9.94442 15.3279 9.98717 15.3712 10.0186C15.4144 10.0501 15.4654 10.0691 15.5187 10.0736L17.0458 10.1961C17.1033 10.2006 17.1581 10.2221 17.2033 10.2578C17.2486 10.2934 17.2823 10.3417 17.3001 10.3965C17.318 10.4513 17.3192 10.5101 17.3036 10.5656C17.2881 10.6211 17.2564 10.6707 17.2127 10.7082L16.0495 11.7046C16.0088 11.7396 15.9786 11.7851 15.9622 11.8361C15.9457 11.8872 15.9436 11.9418 15.9562 11.9939L16.3108 13.4826C16.3245 13.5387 16.3212 13.5977 16.3013 13.652C16.2813 13.7063 16.2457 13.7534 16.199 13.7874C16.1522 13.8214 16.0964 13.8408 16.0386 13.843C15.9809 13.8452 15.9237 13.8302 15.8745 13.7999L14.5678 13.0019C14.5221 12.9741 14.4697 12.9594 14.4162 12.9594C14.3627 12.9594 14.3102 12.9741 14.2645 13.0019L12.9578 13.7999C12.9086 13.8302 12.8515 13.8452 12.7937 13.843C12.7359 13.8408 12.6801 13.8214 12.6333 13.7874C12.5866 13.7534 12.551 13.7063 12.5311 13.652C12.5112 13.5977 12.5078 13.5387 12.5215 13.4826L12.8773 11.9939C12.8899 11.9418 12.8878 11.8872 12.8713 11.8361C12.8549 11.7851 12.8247 11.7396 12.784 11.7046L11.6197 10.7082C11.5755 10.6708 11.5435 10.6211 11.5277 10.5654C11.5119 10.5098 11.513 10.4506 11.5309 10.3956C11.5488 10.3406 11.5826 10.2921 11.6281 10.2564C11.6737 10.2206 11.7288 10.1992 11.7865 10.1949L13.3125 10.0736C13.366 10.0693 13.4173 10.0504 13.4607 10.0189C13.5041 9.98744 13.538 9.94458 13.5587 9.89507L14.1478 8.48107Z"
            fill="white"
          />
        </svg>
      ),
      badge: "BUILT FOR LONG-TERM RESULTS", // Badge text
      checkoutUrl: eliteLink, // Replace with actual checkout link
      priceRaw: 15.99,
      isOneTime: false,
      isMonthly: true,
      priceId: "price_1QVNnLJnrTlLWSIiHLIbMflm",
      unlockProductId: "prod_R3V51NYeGIztoo",
      trialProductId: "prod_RO8biM4NUE1Wws",
      discount: "RIQe98P5",
      experiments: {
        web17_3: {
          discount: "4uRqQtxG",
          newPrice: "$10.00",
          oldPrice: "$15.75",
        }
      }
    },
  ];

  return plans;
}

export function getMultiUserPlans(baseLink: string = "", premiumLink: string = "", eliteLink: string = ""): CheckoutPlan[] {
  return [
    {
      id: "serious",
      isMultiUser: true,
      title: "Getting Serious",
      tagline: "\"I've got goals and I'm carving out time.\"",
      price: "$28.49",
      fullPriceForBoth: "684.00",
      priceDetails: "/ mo",
      description:
        "You’re both still feeling things out, but you’re ready to show up for consistency.",
      icon: null,
      billingDetails: "per person",
      checkoutUrl: premiumLink, // Replace with actual checkout link
      priceRaw: 29.99,
      isOneTime: false,
      isMonthly: true,
      priceId: "price_1TS3zWJnrTlLWSIiYLR2Ltfd",
      unlockProductId: "prod_UQSZlh22efkXGr",
      trialProductId: "prod_RO8biM4NUE1Wws",
      discount: "FRRBtKVo",
      experiments: {
        web17_3: {
          discount: "rfb53wVj",
          newPrice: "$19.99",
          oldPrice: "$29.99",
        }
      },
      tagSavePercentage: "5%",
      tagTheme: "yellow",
    },
    {
      id: "committed",
      isMultiUser: true,
      title: "Fully Committed",
      tagline: "\"This isn't just a phase, it's who I am.\"",
      price: "$13.38",
      fullPriceForBoth: "321.00",
      priceDetails: "/ mo", // Added space for clarity
      billingDetails: "per person (billed annually at $321.00)",
      description:
        "This is your lifestyle now. You're looking for structure and long-term support to help you stay on track.",
      icon: null,
      badge: "FOR LONG-TERM RESULTS", // Badge text
      checkoutUrl: eliteLink, // Replace with actual checkout link
      priceRaw: 15.99,
      isOneTime: false,
      isMonthly: true,
      priceId: "price_1TRbg6JnrTlLWSIi59SQQ7hx",
      unlockProductId: "prod_UQSb22QIyGwuaq",
      trialProductId: "prod_RO8biM4NUE1Wws",
      tagSavePercentage: "15%",
      tagTheme: "green",
    },
  ];
}

// web29 legit timer (anchor arm) — two prices, no coupon.
// The "discounted" price the anchor arm shows IS control's price (the legacy
// Stripe prices below are never touched); the struck-through "regular" price
// is a real Stripe price at today's charge ÷ 0.8, created Sep 2 2026 in the
// production account on the SAME products, so entitlement mapping is unchanged.
// While the offer is live the customer checks out on the legacy price exactly
// like control; once it has expired they check out on the regular price.
// Nothing is discounted in Stripe, so a live-offer subscription is
// indistinguishable from a control one (retention, downgrades, prepay, portal,
// receipts, analytics all behave as they do for control).
export const WEB29_REGULAR_PRICES = {
  serious: { priceId: "price_1UBMkSJnrTlLWSIipEkWjd5K", amount: 37.49 },
  committed: { priceId: "price_1UBMkSJnrTlLWSIiDMopKNjj", amount: 236.25 },
  familySerious: { priceId: "price_1UBMkUJnrTlLWSIi2284Kgbx", amount: 71.25 },
  familyCommitted: { priceId: "price_1UBMkTJnrTlLWSIiCjhygTIw", amount: 401.25 },
} as const;

// web29 anchor arm, offer EXPIRED: control's single-user plans re-pointed at
// the regular (÷0.8) prices. Rendered through control's PricingPlans, so no
// strikethrough or pills — the offer is gone, not hidden.
export function getPlansUrgencyRegular(baseLink: string = "", premiumLink: string = "", eliteLink: string = ""): CheckoutPlan[] {
  const plans = getPlans(baseLink, premiumLink, eliteLink);
  return plans.map((plan) => {
    if (plan.id === "serious") {
      return {
        ...plan,
        priceId: WEB29_REGULAR_PRICES.serious.priceId,
        priceRaw: WEB29_REGULAR_PRICES.serious.amount,
        price: "$37.49",
        priceDetails: "/ month",
        discount: undefined,
        promotionCode: undefined,
      };
    }
    if (plan.id === "committed") {
      return {
        ...plan,
        priceId: WEB29_REGULAR_PRICES.committed.priceId,
        priceRaw: 19.99,
        price: "$19.99",
        priceDetails: "/ month",
        billingDetails: "(billed annually)",
        discount: undefined,
        promotionCode: undefined,
      };
    }
    return plan;
  });
}

// web29 anchor arm, offer EXPIRED: gym-buddy plans at the regular family prices.
export function getMultiUserPlansUrgencyRegular(baseLink: string = "", premiumLink: string = "", eliteLink: string = ""): CheckoutPlan[] {
  const plans = getMultiUserPlans(baseLink, premiumLink, eliteLink);
  return plans.map((plan) => {
    if (plan.id === "serious") {
      return {
        ...plan,
        priceId: WEB29_REGULAR_PRICES.familySerious.priceId,
        priceRaw: 37.49,
        price: "$35.61",
        fullPriceForBoth: "855.00",
        priceDetails: "/ mo",
        billingDetails: "per person",
        discount: undefined,
        promotionCode: undefined,
      };
    }
    if (plan.id === "committed") {
      return {
        ...plan,
        priceId: WEB29_REGULAR_PRICES.familyCommitted.priceId,
        priceRaw: 19.99,
        price: "$16.73",
        fullPriceForBoth: "401.25",
        priceDetails: "/ mo",
        billingDetails: "per person (billed annually at $401.25)",
        discount: undefined,
        promotionCode: undefined,
      };
    }
    return plan;
  });
}

// web29 anchor arm, offer ACTIVE (live countdown, or revived via ?offer=email):
// the urgency UI (banner + PricingPlansWeb21) on CONTROL's plans. Every
// checkout-critical field (priceId, checkoutUrl, unlockProductId,
// trialProductId, id) is byte-identical to control and there is NO coupon:
// checkout rides control's exact create-trial path and the charge is control's
// price. Only DISPLAY fields are overridden — the struck-through "regular"
// price is the real ÷0.8 price (rounded to the anchor values Steven approved,
// e.g. "$19.99" for $236.25/yr) and the pill reads 20% off.
export function getPlansUrgencyAnchor(baseLink: string = "", premiumLink: string = "", eliteLink: string = ""): CheckoutPlan[] {
  const plans = getPlans(baseLink, premiumLink, eliteLink);
  return plans.map((plan) => {
    if (plan.id === "serious") {
      return {
        ...plan,
        price: "$29.99",
        oldPrice: "$37.49",
        priceDetails: "/ month",
        tagSavePercentage: "20%",
        tagTheme: "green",
      };
    }
    if (plan.id === "committed") {
      return {
        ...plan,
        price: "$15.99",
        oldPrice: "$19.99",
        priceDetails: "/ month",
        billingDetails: "(billed annually)",
        badge: "BUILT FOR LONG-TERM RESULTS",
        tagSavePercentage: "20%",
        tagTheme: "green",
      };
    }
    return plan;
  });
}

// web29 anchor arm, offer ACTIVE: gym-buddy plans on CONTROL's family prices,
// no coupon. Pills/copy computed in the anchor universe (control's family
// price vs the regular single price):
//   serious   28.49 vs 37.49 → "24% OFF";  committed 13.38 vs 19.99 → "32% OFF".
export function getMultiUserPlansUrgencyAnchor(baseLink: string = "", premiumLink: string = "", eliteLink: string = ""): CheckoutPlan[] {
  const plans = getMultiUserPlans(baseLink, premiumLink, eliteLink);
  return plans.map((plan) => {
    if (plan.id === "serious") {
      return {
        ...plan,
        price: "$28.49",
        oldPrice: "$35.61",
        fullPriceForBoth: "684.00",
        priceDetails: "/ mo",
        billingDetails: "per person",
        comparisonText: "vs. $37.49/mo each on separate plans",
        tagSavePercentage: "20%",
        tagLabel: "24% OFF",
        tagTheme: "green",
      };
    }
    if (plan.id === "committed") {
      return {
        ...plan,
        price: "$13.38",
        oldPrice: "$16.73",
        fullPriceForBoth: "321.00",
        priceDetails: "/ mo",
        billingDetails: "per person (billed annually at $321.00)",
        comparisonText: "vs. $19.99/mo each on separate plans",
        badge: "FOR LONG-TERM RESULTS",
        tagSavePercentage: "20%",
        tagLabel: "32% OFF",
        tagTheme: "green",
      };
    }
    return plan;
  });
}

// web46 changes display values only: checkout retains the control price
// IDs and applies the arm's coupon — 25% off control's price is 40% off the
// regular anchor, 12.5% off is 30%.
export type Web46DiscountPercent = 30 | 40;

const WEB46_SINGLE_DISPLAY: Record<Web46DiscountPercent, { committed: string; serious: string }> = {
  40: { committed: '$11.99', serious: '$22.49' },
  30: { committed: '$13.99', serious: '$26.24' },
};

const WEB46_MULTI_DISPLAY: Record<Web46DiscountPercent, {
  committed: { price: string; total: string; tag: string };
  serious: { price: string; total: string; tag: string };
}> = {
  40: {
    committed: { price: '$10.04', total: '240.75', tag: '50% OFF' },
    serious: { price: '$21.37', total: '513.00', tag: '43% OFF' },
  },
  30: {
    // Stripe charges $280.87/yr and $49.87/mo (12.5% off $321 / $57).
    committed: { price: '$11.70', total: '280.87', tag: '41% OFF' },
    serious: { price: '$24.93', total: '598.44', tag: '33% OFF' },
  },
};

export function getPlansWeb46Discount(baseLink = "", premiumLink = "", eliteLink = "", percent: Web46DiscountPercent = 40): CheckoutPlan[] {
  return getPlansUrgencyAnchor(baseLink, premiumLink, eliteLink).map(plan => ({
    ...plan,
    price: plan.id === 'committed' ? WEB46_SINGLE_DISPLAY[percent].committed : WEB46_SINGLE_DISPLAY[percent].serious,
    tagSavePercentage: `${percent}%`,
  }));
}

export function getMultiUserPlansWeb46Discount(baseLink = "", premiumLink = "", eliteLink = "", percent: Web46DiscountPercent = 40): CheckoutPlan[] {
  return getMultiUserPlansUrgencyAnchor(baseLink, premiumLink, eliteLink).map(plan => {
    const display = plan.id === 'committed' ? WEB46_MULTI_DISPLAY[percent].committed : WEB46_MULTI_DISPLAY[percent].serious;
    return {
      ...plan,
      price: display.price,
      fullPriceForBoth: display.total,
      billingDetails: plan.id === 'committed' ? `per person (billed annually at $${display.total})` : 'per person',
      tagLabel: display.tag,
      tagSavePercentage: `${percent}%`,
    };
  });
}

const MatchOfferReopen = styled.button`
  display: block;
  margin: 12px auto;
  padding: 8px 16px;
  border: 0;
  background: transparent;
  color: #0b6dff;
  font: 700 16px/22px 'Lato', sans-serif;
  text-decoration: underline;
  cursor: pointer;
`;

export function getSliderCount(timeToGoal: Interval) {
  const timeToGoalTotalMonths = timeToGoal.splitBy({ months: 1 }).length;
  if (timeToGoalTotalMonths > 3) {
    return 4;
  }
  return 3;
}

export function getNextThreeMonths(timeToGoal: Interval) {
  let secondMonth = 1;
  let thirdMonth = 2;
  const timeToGoalTotalMonths = timeToGoal.splitBy({ months: 1 }).length;

  switch (timeToGoalTotalMonths) {
    case 3: {
      secondMonth = 1;
      thirdMonth = 2;
      break;
    }
    case 4: {
      secondMonth = 1;
      thirdMonth = 2;
      break;
    }
    case 5: {
      secondMonth = 1;
      thirdMonth = 3;
      break;
    }
    case 6: {
      secondMonth = 2;
      thirdMonth = 4;
      break;
    }
    case 7: {
      secondMonth = 2;
      thirdMonth = 4;
      break;
    }
    case 8: {
      secondMonth = 2;
      thirdMonth = 5;
      break;
    }
    case 9: {
      secondMonth = 3;
      thirdMonth = 6;
      break;
    }
    case 10: {
      secondMonth = 3;
      thirdMonth = 7;
      break;
    }
    case 11: {
      secondMonth = 4;
      thirdMonth = 7;
      break;
    }
    case 12: {
      secondMonth = 4;
      thirdMonth = 8;
      break;
    }
    default: {
      secondMonth = 1;
      thirdMonth = 2;
      break;
    }
  }

  if (timeToGoalTotalMonths > 12) {
    const timetogoal_total_months_devide = round(timeToGoalTotalMonths / 4);
    secondMonth = timetogoal_total_months_devide;
    thirdMonth = 2 * timetogoal_total_months_devide;
  }

  const monthNames = [
    "jan", "feb", "mar", "apr", "may", "jun",
    "jul", "aug", "sep", "oct", "nov", "dec"
  ].map((month) => i18n.t(`results.transformation.months.${month}`));

  const today = new Date();
  const currentMonth = today.getMonth(); // 0-based index

  return [
    monthNames[(currentMonth + secondMonth) % 12],
    monthNames[(currentMonth + thirdMonth) % 12],
    monthNames[(currentMonth + timeToGoalTotalMonths) % 12]
  ];
}

const LandingPage = (props: LandingPageProps) => {
  const { referral, pending: referralPending } = useReferral();
  const { user, client, survey, isClientLoading, TEST_USE_DURATIONS = false } = props;
  const { t, i18n: i18next } = useTranslation();
  const { chart, timeToGoal } = useChartCalculations(user, true, true);
  const isMobile = useIsMobile();
  const divRef = useRef<HTMLDivElement>(null);

  const sliderscount = getSliderCount(timeToGoal);

  const transformationData = getTransformationData(user, timeToGoal, CDN_ROOT);
 
  const { base: stripeBase, premium: stripePremium, elite: stripeElite, listName: stripeListName } = useAppProgramLevelConfigs(user);

  const isTeen = survey.data['age'] === Age.Teens;

  // The referral offer includes the standard 14-day trial. Do not enroll
  // referred visitors in offers whose session endpoints cannot carry it.
  const web17_3Experiment = referral || referralPending ? undefined : client?.getExperiment("web17_3");
  const web17_3Arm = web17_3Experiment?.value["arm"];
  const isWeb17_3Variation = isTeen && web17_3Arm === 'variation';

  const followingUsAnswer = (survey.data as Record<string, unknown>)['followingus'];
  const isNeverSegment = followingUsAnswer === 'Never';
  const web24Arm = client ? getAssignedExperimentArm('web24_pricing_extras', client) : undefined;
  const isWeb24Variation = isNeverSegment && web24Arm === 'variation';

  // web35_no_trial_urgency: the variation removes the trial everywhere and
  // sells the baseline offer as a pay-today plan; the pricing components get
  // isNoTrial. Control is the site baseline described below.
  const web35Arm = referral || referralPending ? undefined : getWeb35Arm(client);
  const isWeb35NoTrial = web35Arm === 'variation';
  // Site baseline (since Sep 9 2026; formerly web29's urgency-anchor arm): a
  // REAL, stateful timed offer (see web29Offer.ts). While the discount is
  // active (live countdown, or revived via ?offer=email) the page renders the
  // urgency UI (banner + PricingPlansWeb21) on the anchor plans — the shown
  // "discounted" price is the real charge and the struck-through price is a
  // display-only anchor. Once EXPIRED it renders the plain plan UI at the
  // regular (÷0.8) prices with no offer. The clock starts the first time the
  // page renders, survives reloads, and keeps ticking while the user is away
  // on checkout. No coupon in any state.
  const offer = useWeb29Offer(true);
  // Black Friday 2026 sale (bfSale.ts): the sale price for everyone, referral
  // visitors included, with no 10-minute window and no price flip. App also
  // stores it for web29Offer; this covers the first render before that.
  const bfSale = isClientLoading ? null : getBfSale(client);
  const isOfferActive = !!bfSale || (!!offer && offer.isDiscountActive);
  const isOfferExpired = !bfSale && !!offer && !offer.isDiscountActive;
  // Referral visitors keep the standard trial offer: no web46 enrollment.
  // web46 (decided) stays out of the way during the sale.
  const web46Arm = referral || referralPending || bfSale ? undefined : getWeb46Arm(client);
  const [matchState, setMatchState] = useState<MatchOfferState | null>(readMatchOfferState);
  const [isMatchOpen, setIsMatchOpen] = useState(false);
  const matchAttemptedRef = useRef(false);
  // Stored with the offer state in English; the modal shows the same reason in
  // the active language. Amplitude only receives reason.id.
  const matchReason = useMemo(() => pickMatchReason(survey.data, survey.data.name), [survey]);
  const quizLanguage = i18next.language === 'es' ? 'es' : 'en';
  const displayMatchReason = useMemo(
    () => pickMatchReason(survey.data, survey.data.name, quizLanguage),
    [survey, quizLanguage],
  );
  const isSaleDiscount = !!bfSale && !isWeb35NoTrial && !isWeb17_3Variation;
  // The sale and web46 share the coupon display path (getPlansWeb46Discount).
  const isWeb46Discount = isSaleDiscount || (isOfferActive && !isWeb35NoTrial && !isWeb17_3Variation &&
    (web46Arm === 'discount' || web46Arm === 'discount30' || (web46Arm === 'personalization' && !!matchState?.claimedAt)));
  const web46DiscountPercent: Web46DiscountPercent = isSaleDiscount ? bfSale!.percent : web46Arm === 'discount30' ? 30 : 40;
  useEffect(() => {
    if (web46Arm) trackWeb46Exposure(web46Arm);
  }, [web46Arm]);
  // web48_timer_banner: its banner replaces the baseline banner here, counting
  // down to the shared end date; the offer never expires for these visitors
  // (see web48Offer.ts). Exposure is normally logged on the first quiz
  // screen; this covers visitors who arrive straight on pricing.
  const web48Arm = isClientLoading || referral || referralPending ? undefined : getWeb48Arm(client);
  const web48EndsAt = isClientLoading ? undefined : getWeb48EndsAt(client);
  useEffect(() => {
    if (web48Arm) trackWeb48Exposure(web48Arm);
  }, [web48Arm]);

  useEffect(() => {
    if (web17_3Arm) {
      console.log("Experiment started, web17_3", web17_3Arm);
      amplitude.track("ExperimentStarted", {
        experimentName: "web17_3",
        variantName: web17_3Arm,
      });
    }
  }, [web17_3Arm]);

  useEffect(() => {
    if (isNeverSegment && web24Arm) {
      amplitude.track("ExperimentStarted", {
        experimentName: "web24_pricing_extras",
        variantName: web24Arm,
      });
    }
  }, [isNeverSegment, web24Arm]);

  // web35_no_trial_urgency: exposure at pricing-page render, both arms.
  // Paid-ad traffic has no arm (see getWeb35Arm) and logs nothing.
  useEffect(() => {
    if (web35Arm) {
      amplitude.track("ExperimentStarted", {
        experimentName: WEB35_EXPERIMENT_NAME,
        variantName: web35Arm,
      });
    }
  }, [web35Arm]);

  // web40_welcome_kit (paid-ad traffic only): the variation adds the annual
  // welcome kit to the pricing shelf, banner and checkout. Exposure here at
  // the pricing reveal, both arms; organic has no arm and logs nothing.
  // Paid visitors are in web40_welcome_kit, organic visitors in
  // web40_welcome_kit_organic (both US-only); the UI is identical.
  const { experimentName: welcomeKitExperiment, arm: welcomeKitArm, layout: welcomeKitLayout } = getWelcomeKitAssignment(client);
  const isWelcomeKitOn = welcomeKitArm === 'variation';
  // v2 layout (web40_welcome_kit_organic_v2): shelf below the CTA, control banner.
  const isKitBelowCta = isWelcomeKitOn && welcomeKitLayout === 'v2';
  const isKitBannerOn = isWelcomeKitOn && welcomeKitLayout === 'v1';
  useEffect(() => {
    if (welcomeKitArm) {
      amplitude.track("ExperimentStarted", {
        experimentName: welcomeKitExperiment,
        variantName: welcomeKitArm,
      });
    }
  }, [welcomeKitExperiment, welcomeKitArm]);

  // web41_start_date_reservation (organic only): the variation shows the
  // "Ready someday, not today?" entry link under both Start Free Trial buttons.
  // Exposure at the pricing reveal, both arms; paid traffic has no arm.
  const web41Arm = getWeb41Arm(client);
  const isReservationOn = web41Arm === 'variation';
  // web43_gym_buddy_clarity: the variation (two-person total + switch
  // button) is the baseline for everyone since Nov 2026; no exposure.
  const isGymBuddyClarityOn = true;
  useEffect(() => {
    if (web41Arm) {
      amplitude.track("ExperimentStarted", {
        experimentName: WEB41_EXPERIMENT_NAME,
        variantName: web41Arm,
      });
    }
  }, [web41Arm]);

  const programs = useMemo(() => {
    const utm_parameters=generateUtmQueryString();
    const context = client.getContext();
    const stableId = context.stableID;

    let eventSourceUrlParam = '';
    if (document.location.href != null) {
      eventSourceUrlParam = `&eventSourceUrl=${document.location.href}`;
    }

    let referrerParm='';
    if(document.referrer !== ''){
      referrerParm = `&referrer=${encodeURI(document.referrer)}`;
    }
    let referrerDomainParm='';
    try{
      let referrerDomain=document.referrer.split('/')[2];


      if(referrerDomain !== undefined){
        referrerDomainParm= `&referring_domain=${encodeURI(referrerDomain)}`;
      }
    }catch{
      referrerDomainParm='';
    }


    let stableIdParam = '';
    if (stableId != null) {
      stableIdParam = `stableId=${stableId}`;
    }
    const gaClientId = get_ga_clientid();
    let gaParam = '';
    if (gaClientId != null) {
      gaParam = `ga_id=${gaClientId}`;
    }
    const amplitudeId = getAmplitudeDeviceId();
    //console.log('Amplitude Device ID: ', amplitudeId);
    let amplitudeParam = '';
    if (amplitudeId) {
      amplitudeParam = `amplitudeId=${amplitudeId}`;
    }
    // web42: the protein target the quiz showed, for the post-purchase offer.
    const proteinTargetG = getProteinTargetG(user);
    const proteinParam = proteinTargetG ? `protein_target_g=${proteinTargetG}` : '';
    const idParams = [stableIdParam, gaParam, amplitudeParam, proteinParam].filter((p) => p.length > 0).join('&');

    stripeBase.buyLink = `${stripeBase.buyLink}&${idParams}&${utm_parameters}${referrerParm}${referrerDomainParm}${eventSourceUrlParam}`; // ? to & because for base we are using shopify checkout links
    stripePremium.buyLink = `${stripePremium.buyLink}?${idParams}&${utm_parameters}${referrerParm}${referrerDomainParm}${eventSourceUrlParam}`;
    stripeElite.buyLink = `${stripeElite.buyLink}?${idParams}&${utm_parameters}${referrerParm}${referrerDomainParm}${eventSourceUrlParam}`;

    return [stripeBase, stripePremium, stripeElite];
  }, [stripeBase, stripePremium, stripeElite, client]);

  const listName =  stripeListName;

  useEffect(() => {
    saveTimeToGoalToHubspot(user, timeToGoal.toDuration('months').months).then(userId =>{
            const identifyObjUser = new Identify();
          identifyObjUser.set('HubspotUserID',userId);
          amplitude.identify(identifyObjUser);
          });
  }, [user, timeToGoal]);

  useEffect(() => {
    const itemEvent = {
      itemListName: listName,
      items: programs.map((item) => ({
        itemId: item.productId,
        originalPrice: item.price.original,
        price: item.price.current,
        itemName: item.name,
      })),
    };

    const itemEventBasic = {
      itemListName: listName,
      items: programs.filter(item => item.name.includes("Basic"))
      .map(item => ({
        itemId: item.productId,
        originalPrice: item.price.original,
        price: item.price.current,
        itemName: item.name,
      }))
    };

    const itemEventMonthly = {
      itemListName: listName,
      items: programs.filter(item => item.name.includes("Premium"))
      .map(item => ({
        itemId: item.productId,
        originalPrice: item.price.original,
        price: item.price.current,
        itemName: item.name,
      }))
    };

    const itemEventAnnual = {
      itemListName: listName,
      items: programs
      .filter(item => item.name.includes("Elite"))
      .map(item => ({
        itemId: item.productId,
        originalPrice: item.price.original,
        price: item.price.current,
        itemName: item.name,
      }))
    };

    sendViewItemListEvent(itemEvent);
    sendViewItemEvent(itemEventBasic);
    sendViewItemEvent(itemEventMonthly);
    sendViewItemEvent(itemEventAnnual);
    
  }, [programs, listName, TEST_USE_DURATIONS]);


  const pricingTopRef = useSectionInView<HTMLDivElement>({ section: 'pricing_top' });
  const pricingBottomRef = useSectionInView<HTMLDivElement>({ section: 'pricing_bottom' });
  const pageBottomRef = useSectionInView<HTMLDivElement>({ section: 'page_bottom' });

  const handleCtaClickCapture = (location: string) => (event: React.MouseEvent<HTMLDivElement>) => {
    const target = event.target as HTMLElement | null;
    if (target && target.closest('a, button')) {
      trackPricingCtaClicked(location);
    }
  };

  const handleClickScroll = () => {
    trackPricingCtaClicked('hero_scroll_cta');
    const trialPlansAnchor = document.querySelector<HTMLElement>('[data-hero-scroll-anchor="pricing-view-all-plans"]');
    if (trialPlansAnchor) {
      const viewportBottomMargin = 32;
      const offsetPosition = window.pageYOffset + trialPlansAnchor.getBoundingClientRect().bottom - window.innerHeight + viewportBottomMargin;
      window.scrollTo({
        top: Math.max(0, offsetPosition),
        behavior: 'smooth'
      });
      return;
    }

    const pricingSection = document.getElementById('pricingbox');
    if (pricingSection) {
      const elementPosition = pricingSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 60; // 60px padding from top
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const startNowButton = <StartNowButton onClick={handleClickScroll}>
    {isWeb35NoTrial ? t("results.page.getMyPlan") : t("results.page.startFreeTrial")}
    </StartNowButton>;

  const [isLoading, setIsLoading] = useState(true);
  const [isPlanIsReadyVisible, setIsPlanIsReadyVisible] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);
  // web40 variation: the welcome-kit intro screen (Ethan's post-loading
  // pop-up) replaces the plan-ready beat; "Show me my plan" fades it out
  // straight into the pricing page.
  const [isKitIntroVisible, setIsKitIntroVisible] = useState(false);
  const [isKitIntroFadingOut, setIsKitIntroFadingOut] = useState(false);

  // Baseline plan data. Offer active → the urgency UI shows the anchor plans
  // (control's price ids with anchor DISPLAY values); offer expired → the
  // plain plan UI shows the regular (÷0.8) prices.
  const myPricingPlansData = isOfferExpired
    ? getPlansUrgencyRegular(stripeBase.buyLink, stripePremium.buyLink, stripeElite.buyLink)
    : getPlans(stripeBase.buyLink, stripePremium.buyLink, stripeElite.buyLink);
  const multiUserPricingPlansData = isOfferExpired
    ? getMultiUserPlansUrgencyRegular(stripeBase.buyLink, stripePremium.buyLink, stripeElite.buyLink)
    : getMultiUserPlans(stripeBase.buyLink, stripePremium.buyLink, stripeElite.buyLink);
  const urgencyUiPlans = isWeb46Discount
    ? getPlansWeb46Discount(stripeBase.buyLink, stripePremium.buyLink, stripeElite.buyLink, web46DiscountPercent)
    : getPlansUrgencyAnchor(stripeBase.buyLink, stripePremium.buyLink, stripeElite.buyLink);
  const urgencyUiMultiUserPlans = isWeb46Discount
    ? getMultiUserPlansWeb46Discount(stripeBase.buyLink, stripePremium.buyLink, stripeElite.buyLink, web46DiscountPercent)
    : getMultiUserPlansUrgencyAnchor(stripeBase.buyLink, stripePremium.buyLink, stripeElite.buyLink);

  const handleLoadingDone = useCallback(() => {
    // Start fade-out animation
    setIsFadingOut(true);

    // After fade-out completes, set isLoading to false
    setTimeout(() => {
      setIsLoading(false);
      if (isWelcomeKitOn) {
        setIsKitIntroVisible(true);
      } else {
        setIsPlanIsReadyVisible(true);
        setTimeout(() => {
          setIsPlanIsReadyVisible(false);
        }, 2000);
      }
    }, 450); // 300ms matches the CSS transition duration
  }, [isWelcomeKitOn]);

  const handleKitIntroContinue = useCallback(() => {
    setIsKitIntroFadingOut(true);
    setTimeout(() => {
      setIsKitIntroVisible(false);
      setIsKitIntroFadingOut(false);
    }, 450);
  }, []);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useWindowResize(setWindowWidth);
 
  useEffect(() => {
      const handleResize = () => {
          setWindowWidth(window.innerWidth);
      };

      window.addEventListener("resize", handleResize);
      return () => {
          window.removeEventListener("resize", handleResize);
      };
  }, []);

  const devHelper = useDevHelper();

  const isPricingVisible = (!isLoading || devHelper.isLoadingOnLandingPageDisabled) &&
    !isPlanIsReadyVisible && !isKitIntroVisible;
  useEffect(() => {
    if (!isOfferActive || web46Arm !== 'personalization') setIsMatchOpen(false);
  }, [isOfferActive, web46Arm]);
  useEffect(() => {
    if (!isPricingVisible || !isOfferActive || web46Arm !== 'personalization' ||
        isWeb35NoTrial || isWeb17_3Variation || matchState?.shownAt || matchAttemptedRef.current) return;
    matchAttemptedRef.current = true;
    if (!matchReason) {
      amplitude.track('match_offer_skipped', { why: 'missing_describeSelf' });
      return;
    }
    const state = { shownAt: Date.now(), reason: matchReason };
    writeMatchOfferState(state);
    setMatchState(state);
    setIsMatchOpen(true);
    amplitude.track('match_offer_modal_shown', { reason: matchReason.id });
  }, [isPricingVisible, isOfferActive, web46Arm, isWeb35NoTrial, isWeb17_3Variation, matchState, matchReason]);

  const dismissMatchOffer = (method: 'no_thanks' | 'close' | 'escape') => {
    if (!matchState) return;
    const state = { ...matchState, dismissedAt: Date.now() };
    writeMatchOfferState(state);
    setMatchState(state);
    setIsMatchOpen(false);
    amplitude.track('match_offer_dismissed', { reason: state.reason.id, method });
  };
  const claimMatchOffer = () => {
    if (!matchState || !isOfferActive) return;
    const state = { ...matchState, claimedAt: Date.now() };
    writeMatchOfferState(state);
    setMatchState(state);
    setIsMatchOpen(false);
    amplitude.track('match_offer_claimed', { reason: state.reason.id });
  };
  const matchName = typeof survey.data.name === 'string' ? survey.data.name.trim() : '';
  const web46BannerLead = web46Arm === 'personalization'
    ? (matchName ? t('results.banner.matchOfferUnlockedNamed', { name: matchName }) : t('results.banner.matchOfferUnlocked'))
    : t('results.banner.specialDiscountUnlocked');
  const percentOffTrial = (percent: number) => t('results.banner.percentOffTrial', { percent });

  // QA: when the landing loading is disabled (debug aliases), the web40
  // intro cannot be reached through the loading callback, so open it on
  // mount instead; "Show me my plan" then lands on the pricing page as usual.
  useEffect(() => {
    if (devHelper.isLoadingOnLandingPageDisabled && isWelcomeKitOn) {
      setIsKitIntroVisible(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const items = getLandingPageSurveyItems(user);

  if (isLoading && !devHelper.isLoadingOnLandingPageDisabled) {
    return (
      <>
        <LoadingPageV2 items={items} onComplete={handleLoadingDone} isFadingOut={isFadingOut} />
      </>
    )
  }

  if (isKitIntroVisible) {
    return <WelcomeKitIntro onContinue={handleKitIntroContinue} isFadingOut={isKitIntroFadingOut} />;
  }

  if (isPlanIsReadyVisible) {
    return (
      <>

        <LoadingPagePlanReady />
      </>
    );
  }

  return (
    <>
      {/* Baseline offer banner: sticky countdown bar above the pricing while
          the offer is active. The countdown runs to the persisted deadline;
          no clock at all when revived via ?offer=email. */}
      {bfSale ? (
        <Web48Banner arm={getBfBannerDesign(bfSale, web48Arm)} sale={bfSale} />
      ) : web48Arm ? (
        <Web48Banner arm={web48Arm} endsAt={web48EndsAt} />
      ) : isOfferActive && (
        <Quiz4UrgencyBanner
          // web40 variation: same banner, only the copy names the kit.
          // Kit copy is one phrase in title case (Ethan, Sep 19: no all caps), on
          // its own mobile line (no small lead-in line).
          // web35 (no-trial) and the welcome kit are decided Control: their
          // variation-only lines stay English.
          line1={isWeb46Discount ? web46BannerLead : isKitBannerOn ? "" : isWeb35NoTrial ? "20% Off" : t('results.banner.specialDiscountUnlocked')}
          line2={isWeb46Discount ? percentOffTrial(web46DiscountPercent) : isKitBannerOn ? "Save 20% +\nFree Welcome Kit" : isWeb35NoTrial ? "Discount Unlocked" : percentOffTrial(20)}
          line3={isWeb46Discount ? `${web46BannerLead} ${percentOffTrial(web46DiscountPercent)}` : isKitBannerOn ? "Save 20% + Free Welcome Kit" : isWeb35NoTrial ? "20% Off Discount Unlocked" : undefined}
          showTimer={!!offer?.showCountdown}
          expiresAt={offer?.expiresAt}
          showBanner={true}
        />
      )}
      {web46Arm === 'personalization' && isOfferActive && matchState && !matchState.claimedAt && !isWeb35NoTrial && !isWeb17_3Variation && (
        <MatchOfferReopen onClick={() => {
          setIsMatchOpen(true);
          amplitude.track('match_offer_reopened');
          amplitude.track('match_offer_modal_shown', { reason: matchState.reason.id });
        }}>{t('results.page.seeMatchOffer')}</MatchOfferReopen>
      )}
      {isMatchOpen && isOfferActive && web46Arm === 'personalization' && matchState && (
        <MatchOfferModal
          reason={displayMatchReason?.id === matchState.reason.id ? displayMatchReason : matchState.reason}
          onClaim={claimMatchOffer}
          onDismiss={dismissMatchOffer}
        />
      )}
      {(isWeb17_3Variation) ? <Banner text={t('results.banner.studentRate')} /> : null}
      <LandingPageContainerSlider>
        <ChartWrapper>{chart}</ChartWrapper>
        <SliderSection>
          <SliderContairner>
            {isMobile ? <TransformationSlider sliderscount={sliderscount} transformationData={transformationData} ></TransformationSlider> : <TransformationSliderDesktop sliderscount={sliderscount} transformationData={transformationData} key={windowWidth}></TransformationSliderDesktop>}
          </SliderContairner>
          <StartButtonWrapperSlider>
            {startNowButton}
            {isReservationOn && !isWeb35NoTrial && <ReservationEntry position="hero" />}
          </StartButtonWrapperSlider>
        </SliderSection>
        
        <div ref={pricingTopRef} onClickCapture={handleCtaClickCapture('pricing_top')}>
          {isOfferActive ? (
            <PricingPlansWeb21
              ref={divRef}
              plans={urgencyUiPlans}
              multiUserPlans={urgencyUiMultiUserPlans}
              user={user}
              survey={survey}
              isNoTrial={isWeb35NoTrial}
              welcomeKitOn={isWelcomeKitOn} welcomeKitBelowCta={isKitBelowCta} reservationOn={isReservationOn} gymBuddyClarityOn={isGymBuddyClarityOn}
            />
          ) : (
            <PricingPlans plans={myPricingPlansData} multiUserPlans={multiUserPricingPlansData} user={user} survey={survey} isNoTrial={isWeb35NoTrial} welcomeKitOn={isWelcomeKitOn} welcomeKitBelowCta={isKitBelowCta} reservationOn={isReservationOn} gymBuddyClarityOn={isGymBuddyClarityOn} />
          )}
        </div>

        {isWeb24Variation && (
          <>
            <PricingExtrasWeb24 user={user} />
            <div ref={pricingBottomRef} onClickCapture={handleCtaClickCapture('pricing_bottom')}>
              {isOfferActive ? (
                <PricingPlansWeb21
                  plans={urgencyUiPlans}
                  multiUserPlans={urgencyUiMultiUserPlans}
                  user={user}
                  survey={survey}
                  isNoTrial={isWeb35NoTrial}
                  welcomeKitOn={isWelcomeKitOn} welcomeKitBelowCta={isKitBelowCta} reservationOn={isReservationOn} gymBuddyClarityOn={isGymBuddyClarityOn}
                />
              ) : (
                <PricingPlans plans={myPricingPlansData} multiUserPlans={multiUserPricingPlansData} user={user} survey={survey} isNoTrial={isWeb35NoTrial} welcomeKitOn={isWelcomeKitOn} welcomeKitBelowCta={isKitBelowCta} reservationOn={isReservationOn} gymBuddyClarityOn={isGymBuddyClarityOn} />
              )}
            </div>
          </>
        )}

        <SliderSectionFixed ref={pageBottomRef}>
          <RestartQuizButton
            onClick={() => {
              localStorage.removeItem('BWS_SURVEY_DATA');
              window.location.href = '/page/1';
            }}
          >
            {t('results.page.restartQuiz')}
          </RestartQuizButton>
        </SliderSectionFixed>
      </LandingPageContainerSlider>
      <Footer />
    </>
  );
};

export { LandingPage };
